import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route (pathname) change.
 * Skips when only the hash changes — Index.tsx handles hash-based scrolling.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let hash handler scroll to the section
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
